// types
export const SET_FILTER = 'SET_FILTER';
export const CLEAR_FILTER = 'CLEAR_FILTER';

// filter ids
export const USER_FILTER = 'USER_FILTER';
export const CONTENT_FILTER = 'CONTENT_FILTER';

// actions
export const setFilter = (id, filter) => {
  return {
    type: SET_FILTER,
    payload: {
      filterID: id,
      filter: filter,
    }
  }
}

export const clearFilter = (id) => {
  return {
    type: CLEAR_FILTER,
    payload: {
      filterID: id,
    }
  }
}